<template>
  <div class="row">
    <div class="col-md-12 padding-left-0 padding-right-0">
      <p><strong class="ms-font-base md-font-xl">Terms of Use</strong></p>
      <div class="terms-container">
        <h3>IMPORTANT PLEASE READ CAREFULLY</h3>

        <h4>Website operation &nbsp;</h4>

        <p class="ms-font-base md-font-xl">
          This website is owned and operated by J.M.L.A Holdings Pty Ltd ACN 007
          885 350 trading as The Rent Roll Broker (collectively,
          &quot;JMLA&quot;, &quot;The Rent Roll Broker&quot;, &quot;we&quot;,
          &quot;us&quot; or &quot;our&quot;) under the domain name
          www.therentrollbroker.com.au (&quot;the Website&quot;).&nbsp;
        </p>

        <h4>No warranty</h4>

        <p class="ms-font-base md-font-xl">
          While JMLA has made every effort to ensure that the information
          presented in the Website is free from errors or omissions and/or is
          suitable for your intended use, JMLA does not warrant the accuracy,
          adequacy or completeness of any information contained in the Website.
          To the maximum extent permissible by law, JMLA disclaims all liability
          and responsibility for any direct or indirect loss or damage suffered
          by any person or entity in reliance on the information presented in
          the Website or omitted from the Website.
        </p>

        <h4>Access to the Website and use of the services</h4>

        <p class="ms-font-base md-font-xl">
          Your access to and use of the information, materials and services
          provided on the Website is conditional upon your acceptance and
          compliance with the terms, conditions, statements, notices, policies
          and disclaimers contained on this Website
          (&quot;Terms&quot;).&nbsp;<br />
          <br />
          Your continued use of the Website means you accept these Terms. If you
          do not wish to be bound by these Terms you must discontinue accessing,
          browsing and/or using the Website.&nbsp;<br />
          <br />
          We reserve the right to amend these Terms at any time. In such an
          event, we will provide notice by publishing the varied Terms on the
          Website. You accept that by doing this, we have provided you with
          sufficient notice of the variation.
        </p>

        <h4>Intellectual property rights&nbsp;</h4>

        <p class="ms-font-base md-font-xl">
          The material contained on this Website is protected by copyright.<br />
          <br />
          Except to the extent permitted by relevant copyright legislation, you
          must not use, reproduce, modify, adapt, transmit, store, print,
          publish or distribute the material on the Website, or create any other
          material using material on the Website, without obtaining our prior
          written consent.<br />
          <br />
          The trademarks appearing on the Website (whether registered or
          unregistered) are primarily our trademarks or of those of our
          affiliates or advertisers. Other trademarks which may be displayed on
          the Website are trademarks of their respective owners. Such trademarks
          must not be used or modified in any way without our express written
          consent or the relevant affiliate or third party owner.<br />
          <br />
          You agree that all the materials displayed on or available through the
          Website, including without limitation any and all names, logos, data,
          information, text, graphics, advertisements and underlying software
          displayed on or available from the Website are protected by copyright,
          trademark and other intellectual property laws and are available for
          your personal use only.<br />
          <br />
          The Website, products, technology and processes contained in this
          website may be the subject of other intellectual property rights owned
          by JMLA or by third parties. No licence is granted in respect of those
          intellectual property rights other than as set out in these Terms.
          Your use of the Website must not in any way infringe the intellectual
          property rights of any person.&nbsp;
        </p>

        <h4>Third party website links</h4>

        <p class="ms-font-base md-font-xl">
          The Website may contain links and pointers to other websites operated
          by third parties. Such links and pointers are provided for your
          information and convenience only. We make no representations about the
          accuracy or suitability of the information or links which may be
          provided on the Website. JMLA does not control these third party
          websites and cannot be responsible for the content or accuracy of the
          information or other material contained on these websites.<br />
          <br />
          Unless otherwise expressly stated on the Website, the provision of a
          link to an external website does not constitute an endorsement or
          approval of that website, its operator and/or any products or services
          offered on or through that website.<br />
          <br />
          It is strongly recommended that you seek independent expert advice if
          you have any concerns regarding any services, products or solutions
          that may be suitable for you.<br />
          <br />
          Before using other websites, we strongly recommend you examine the
          terms and conditions governing the use of those websites as they may
          differ from the Website. Similarly, before disclosing your personal
          information on any other website, we advise you to examine the privacy
          policies of those websites.<br />
          <br />
          You agree that by accessing any third party linked website you do so
          at entirely at your own risk. JMLA will not be responsible or liable,
          directly or indirectly, for any damage or loss caused or alleged to be
          caused by or in connection with, use or reliance on any goods or
          services available on or through any third party website.<br />
          <br />
          Hyperlinks to the Website are only permitted where prior written
          consent has been obtained.&nbsp;
        </p>

        <h4>Right to modification and change&nbsp;</h4>

        <p class="ms-font-base md-font-xl">
          We reserve the right to amend, modify, delete and make changes and
          corrections to any part of the Website at any time without notice.
          JMLA does not guarantee continued availability of any particular
          product or service advertised or referred to on the Website.&nbsp;
        </p>

        <h4>Information does not represent professional advice</h4>

        <p class="ms-font-base md-font-xl">
          The information and material provided on or through the Website is
          provided as general information only and should not be regarded as a
          substitute for professional legal or financial advice. Prior to
          entering into a transaction or taking any particular course of action
          in connection with the information you receive from the Website, you
          should make your own inquiries and seek independent advice tailored to
          your specific circumstances and objectives.
        </p>

        <h4>No guarantees as to the services</h4>

        <p class="ms-font-base md-font-xl">
          The Website may contain downloadable materials and links to external
          websites.<br />
          <br />
          JMLA is not responsible for, and has no control over, the content of
          downloadable materials or external websites.<br />
          <br />
          You understand that we cannot and do not guarantee, warrant or
          represent that a file or software of any kind, or from any source,
          available for downloading through the Website, will be free of
          infection or viruses, worms, Trojan horses or other code or defects
          that manifest contaminating or destructive properties.&nbsp;
        </p>

        <h4>Disclaimer and limitation of liability&nbsp;</h4>

        <p class="ms-font-base md-font-xl">
          Certain rights and remedies may be available under the Trade Practices
          Act 1974 or similar legislation of other States or Territories and may
          not be permitted to be excluded, restricted or modified. Apart from
          those that cannot be excluded, JMLA and its related entities exclude
          all conditions and warranties that may be implied by law. To the
          extent permitted by law, our liability for breach of any implied
          warranty or condition that cannot be excluded is restricted, at our
          option to: the re-supply of services or payment of the cost of
          re-supply of services; or the replacement or repair of goods or
          payment of the cost of replacement or repair.
        </p>

        <h4>Privacy&nbsp;</h4>

        <p class="ms-font-base md-font-xl">By using the Website, you agree to our Privacy Policy.</p>

        <h4>Security&nbsp;</h4>

        <p class="ms-font-base md-font-xl">
          When using the World Wide Web, the Internet or third party networks or
          facilities, you are using networks, facilities and services that are
          beyond our control. You assume all risk and liability of your use of
          the World Wide Web, the Internet or any such third party networks,
          including any access to the Website via such media.&nbsp;
        </p>

        <h4>Jurisdiction</h4>

        <p class="ms-font-base md-font-xl">
          The use of the Website is governed by, construed and enforced in
          accordance with the laws of South Australia, Australia and you
          irrevocably submit to the non-exclusive jurisdiction of the courts of
          South Australia, Australia and its respective courts of appeal in that
          regard.<br />
          <br />
          The Website may be accessed throughout Australia and overseas. JMLA
          makes no representations that the content of the Website complies with
          the laws (including intellectual property laws) of any country outside
          Australia. If you access this website from outside Australia, you do
          so at your own risk and are responsible for complying with the laws in
          the place where you access the Website.
        </p>

        <h4>Severability</h4>

        <p class="ms-font-base md-font-xl">
          If any part of these Terms is held invalid, illegal or unenforceable,
          that part shall be severed and the remainder will continue to be valid
          and enforceable.
        </p>

        <h4>Reservation of rights&nbsp;</h4>

        <p class="ms-font-base md-font-xl">
          Any rights not expressly granted to you herein are reserved by
          JMLA.&nbsp;
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
